import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';

import './swiper-menu.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Swiper.Menu',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-swiper-menu',
      left: 'uu5-bricks-swiper-menu-left',
      right: 'uu5-bricks-swiper-menu-right',
      open: 'uu5-bricks-swiper-menu-open'
    },
    defaults: {
      parentTagName: 'UU5.Bricks.Swiper'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    pullRight: React.PropTypes.bool,
    _open: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      pullRight: false,
      _open: false
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount: function () {
    this.checkParentTagName(this.getDefault().parentTagName);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    var mainAttrs = this.buildMainAttrs();

    mainAttrs.className += ' ' + (this.props.pullRight ? this.getClassName().right : this.getClassName().left);
    this.props._open && (mainAttrs.className += ' ' + this.getClassName().open);

    return (
      this.getNestingLevel()
        ? (
          <div {...mainAttrs}>
            {this.getChildren()}
            {this.getDisabledCover()}
          </div>
        ) : null
    );
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/swiper-menu.js